import React from 'react'

const AccountsDashboard = () => {
  return (
    <div>AccountsDashboard</div>
  )
}

export default AccountsDashboard